<template>
    <div class="px-5 d2d-onboarding speq">
        <div class="row d2d-header mb-5">
            <div class="col-md-12 pt-4">
                <h1>Welcome to SilencerCo’s Speq Program</h1>
                <p>Please read the following license agreement carefully.</p>
                <div class="speq-onboarding-agreement">
                    <p>
                        <b>SPEQ DEALER TERMS AND CONDITIONS</b>
                    </p>
                    <p>
                        These SPEQ Dealer Terms and Conditions (these “Terms”), dated as of the date of acceptance by Dealer (as defined below) are entered into by and between 
                        SilencerCo Weapons Research, LLC, a Utah limited liability company d/b/a SilencerCo (“SilencerCo”), and the applicable dealer of firearms and participant in the SPEQ Program (“Dealer”). 
                        SilencerCo and Dealer are sometimes hereinafter referred to each as “Party” and collectively, the “Parties.”
                    </p>
                    <p>
                        <b>RECITALS</b>
                        <ul class="no-bullets">
                            <li>A. SilencerCo is engaged in the business of manufacturing and selling firearms suppression systems and related accessories; </li>
                            <li>B. Dealer is a holder of a FFL issued by the ATF, a registered SOT with the ATF and is engaged in the business of retail sales of firearms and related accessories; and</li>
                            <li>C. SilencerCo desires to engage Dealer as its non-exclusive distributor and dealer to participate in the SPEQ Program and sell SilencerCo Products to SPEQ Customers and Dealer desires to accept such engagement pursuant to the terms and conditions of these Terms.</li>
                        </ul>
                    </p>
                    <p>
                        <b>AGREEMENT</b>
                    </p>
                    <p>
                        NOW THEREFORE, in consideration of the foregoing, and the representations, warranties, and conditions set forth below, the parties hereto, intending to be legally bound, hereby agree as follows:
                    </p>
                    <ol>
                        <li>
                            <p>
                                <b><i>Defined Terms.</i></b> Capitalized terms shall have the meanings ascribed to such terms herein and those certain terms are defined as set forth below: 
                            </p>
                            <p>
                                <b>“Affiliate”</b> means with respect to any Person, any Person that directly or indirectly controls, is controlled by or is under common control with such Person.
                            </p>
                            <p>
                                <b>“ATF”</b> means the Bureau of Alcohol, Tobacco, Firearms and Explosives. 
                            </p>
                            <p>
                                <b>“Business Day”</b> means any other day than (i) a Saturday or Sunday or (ii) a day on which commercial banks in Salt Lake City, Utah are closed in observance of a U.S. federal holiday.
                            </p>
                            <p>
                                <b>“Dealer Locations”</b> means the brick-and-mortar storefront (excluding any primary residence of a Dealer) location(s) where Dealer maintains a FFL, registers as a SOT and sells firearms and related accessories.
                            </p>
                            <p>
                                <b>“Dealer Portal”</b> means the on-line portal hosted by SilencerCo whereby Dealers: (a) upload all required documentation, (b) access historical sales data, and (c) receive written notices and updates related to the sales of SilencerCo Products to SPEQ Customers.
                            </p>
                            <p>
                                <b>“FFL”</b> means any class of federal firearms license as issued by the AFF which qualifies dealer to register as a SOT. 
                            </p>
                            <p>
                                <b>“Fraud”</b> means fraud as defined pursuant to Delaware common law.
                            </p>
                            <p>
                                <b>“Governmental Authority”</b> means any federal, state, local, or foreign government or political subdivision thereof, or any agency or instrumentality of such government or political subdivision, or any self-regulated organization or other non-governmental regulatory authority or quasi-governmental authority (to the extent that the rules, regulations, or orders of such organization or authority have the force of Law), or any arbitrator, court, or tribunal of competent jurisdiction.
                            </p>
                            <p>
                                <b>“Governmental Order”</b> means any order, writ, judgment, injunction, decree, stipulation, award or determination entered by or with any Governmental Authority.
                            </p>
                            <p>
                                <b>“Law”</b> means any statute, law, ordinance, regulation, rule, code, constitution, treaty, common law, Governmental Order, or other requirement or rule of law of any Governmental Authority.
                            </p>
                            <p>
                                <b>“LOA”</b> means a Letter of Authorization issued by the ATF to continue operations for a period of six months pending the processing of the Renewal Application. 
                            </p>
                            <p>
                                <b>“Losses”</b> means losses, costs, expenses, liabilities, damages, fines, and penalties, including court costs, reasonable attorneys’ and professionals’ fees and expenses, and other litigation or settlement expenses.
                            </p>
                            <p>
                                <b>“Person”</b> means any individual, sole proprietorship, partnership, joint venture, trust, unincorporated association, corporation, limited liability company, entity or governmental authority.
                            </p>
                            <p>
                                <b>“Renewal Application”</b> means a FFL Renewal Application to annually renew a Dealer’s FFL as mandated by the ATF.  
                            </p>
                            <p>
                                <b>“Required Insurance”</b> means the minimum insurance coverage required to be carried by the Dealer for its applicable FFL.
                            </p>
                            <p>
                                <b>“SilencerCo IP Rights”</b> means all forms of intellectual property rights and other proprietary rights and protections throughout the world relating to the SilencerCo Products and Services, including all (a) patents and statutory invention registrations (including any patent applications, together with all continuations, continuations-in-part, divisions, extensions, provisionals, reexaminations, reissues, renewals and revisions), inventions, discoveries, improvements, methods and processes; (b) copyrights and other published and unpublished works of authorship, including audiovisual works, collective works, software, compilations, databases, derivative works, literary works, mask works, and sound recordings; (c) trademarks, service marks, trade dress, trade names, corporate names and other source identifiers, together with all goodwill associated therewith; (d) Internet domain names; (e) trade secrets under applicable Law, proprietary information, technical information, know-how and other information not generally known or readily ascertainable through proper means, whether tangible or intangible, including algorithms, customer lists, ideas, designs, formulas, know-how, methods, processes, programs, prototypes, systems, and techniques; (f) rights in databases and designs (ornamental or otherwise); (g) rights of attribution and integrity and other moral rights of an author; and (h) rights in, arising out of, or associated with a person’s name, voice, signature, photograph, or likeness, including rights of personality, privacy, and publicity and similar rights, in each case whether currently existing or hereafter developed or acquired, arising under statutory law, common law, or by contract, and whether or not perfected, registered or issued, including all applications, disclosures, registrations, issuances, renewals and extensions with respect thereto.
                            </p>
                            <p>
                                <b>“SilencerCo Products”</b> means collectively, any firearm products and accessories manufactured by SilencerCo and sold to Dealer for SPEQ Sales pursuant to the terms of these Terms. 
                            </p>
                            <p>
                                <b>“SOT”</b> means a Class 3 Special Occupation Taxpayer that holds a FFL and pays a special annual tax and annually registers with the ATF in order to be a dealer of firearms (including silencers) that are regulated under the National Firearms Act of 1934. 
                            </p>
                            <p>
                                <b>“SPEQ Customers”</b> means any of the following (i) sworn federal, state, county, city and other local law enforcement officers, (ii) any such law enforcement officers that have been issued “retired” credentials, (iii) any persons in official training to become such a law enforcement officer combined with evidence of enrollment in an official training academy, (iv) emergency medical technicians and paramedics, (v) firefighters (both voluntary and paid), (vi) military personnel, including active duty, reserved status national guard and retired military with applicable DD 214 identification, (vii) corrections officers, including parole and probation officers, (viii) state licensed security company, (ix) state licensed armed security officers and professionals, and (x) sworn federal, state, county, city and other local judges, district attorneys and deputy district attorneys. 
                            </p>
                            <p>
                                <b>“SPEQ Program”</b> means the dealer program of SilencerCo whereby such dealers facilitate SPEQ Sales. 
                            </p>
                            <p>
                                <b>“SPEQ Sales”</b> means resales of SilencerCo Products to SPEQ Customers.
                            </p>
                        </li>
                        <li>
                            <b><i>SPEQ Sales Dealer.</i></b> SilencerCo hereby engages Dealer as its non-exclusive distributor and dealer to facilitate SPEQ Sales and Dealer desires to accept such 
                            engagement pursuant to the terms and conditions of these Terms. SilencerCo expressly reserves the right to appoint additional dealers and/or limit the number of dealers 
                            in any particular geographic area. 
                        </li>
                        <li>
                            <b><i>Conditions Precedent.</i></b> The effectiveness of these Terms and Dealer’s participation in the SPEQ Program are subject to the satisfaction of the following conditions precedent, 
                            in each case, acceptable to SilencerCo, as determined in its the sole discretion, and these Terms and Dealer’s participation in the SPEQ Program shall be effective on the 
                            date of full satisfaction thereof (the <b>“Effective Date”</b>):
                            <ol class="custom-bullets">
                                <li>Dealer shall deliver to SilencerCo a copy of a valid FFL or LOA which it is operating under (Dealer shall in a timely manner also provide SilencerCo written notice of any communications from the ATF regarding Dealer’s then current FFL or LOA);</li>
                                <li>Dealer shall deliver to SilencerCo evidence that Dealer is a SOT and in compliance with all registration and tax obligations related thereto;</li>
                                <li>Dealer shall deliver to SilencerCo all contact information for any responsible persons identified in Dealer’s FFL;</li>
                                <li>Dealer shall deliver to SilencerCo any state and local occupational licenses and resale tax certificates as required to be held by Dealer pursuant to its applicable FFL; </li>
                                <li>Dealer shall deliver to SilencerCo a fully completed IRS Form W-9, duly executed by Dealer; and </li>
                                <li>Dealer shall deliver to SilencerCo all other documents and certificates as SilencerCo or its counsel may reasonably request relating to these Terms and any other legal matters relating to Dealer, all in form and substance reasonably satisfactory to SilencerCo and its counsel. </li>
                            </ol>
                        </li>
                        
                        <li>
                            <b><i>Pricing.</i></b> The prices for the SilencerCo Products shall be as listed on the Dealer Portal and shall be subject to change at anytime by SilencerCo in its sole discretion upon 60 days prior notice to Dealer. 
                            All prices paid by Dealer for the SilencerCo Products are strictly confidential and subject to the terms of the Confidentiality Agreement. 
                        </li>
                        <li>
                            <b><i>Inventory.</i></b>
                            <ol class="custom-bullets">
                                <li>Product Orders. All orders of SilencerCo Products by Dealer must be initiated and requested through the Dealer Portal. The initial order by a Dealer must be a minimum of five SilencerCo Products. </li>
                                <li>Minimum Inventory. Dealer must maintain a minimum of five SilencerCo Products on hand in inventory at all times during the Term. </li>
                                <li>Maximum Inventory. Dealer shall not maintain an inventory in excess of 25 SilencerCo Products on hand in inventory without the express prior written consent of SilencerCo. </li>
                            </ol>
                        </li>
                        <li>
                            <b><i>Shipping and Delivery.</i></b> SilencerCo shall ship and deliver the SilencerCo Products for SPEQ Sales to Dealer at the applicable Dealer Location at the sole cost 
                            and expense of Dealer and the risk of loss to any SilencerCo Products shall transfer to Dealer upon its receipt of such SilencerCo Products.
                        </li>
                        <li>
                            <b><i>Products Returns.</i></b> No SilencerCo Products shall be eligible for return to SilencerCo after the ATF Form 3 has been filed with the ATF. 
                            Prior to submission of an ATF Form 3 SilencerCo Products may be returned to SilencerCo pursuant to the terms and conditions of SilencerCo’s 
                            general terms and conditions of sale as then in effect. 
                        </li>
                        <li>
                            <b><i>SPEQ Sales.</i></b>
                            <ol class="custom-bullets">
                                <li>
                                    <i>Sales Requirements.</i> Dealer agrees to the following requirements for SPEQ Sales:
                                    <ul class="no-bullets">
                                        <li>(i) Dealer shall sell the SilencerCo Products in accordance with the suggested retail pricing guidelines provided by SilencerCo;</li>
                                        <li>(ii) Dealer shall only facilitate SPEQ Sales (A) within the state designated on its applicable FFL, and (B) at the designated Dealer Locations, which does not include nor permit e-commerce or trade show sales in any manner; </li>
                                        <li>(iii) Dealer shall only sell the SilencerCo Products purchased pursuant to these Terms to SPEQ Customers that are verified as such with valid credentials issued by the applicable Governmental Authority (“Official Credentials”); and </li>
                                        <li>(iv) Within 30 days following each SPEQ Sale, Dealer shall upload to the Dealer Portal all sales documentation for each such SPEQ Sale, including a sales receipt, copy of Official Credentials and completed and filed ATF Form 4.  </li>
                                    </ul>
                                </li>
                                <li>
                                    <i>Additional Sales Requirements.</i> Dealer will comply with all Laws regarding the sale and transfer of firearms, including:
                                    <ul class="no-bullets">
                                        <li>(i) Laws regarding background checks, including photograph processing, fingerprinting and any other required regulatory diligence; </li>
                                        <li>(ii) Completion of an ATF Form 4473 (or its electronic equivalent);</li>
                                        <li>(iii) Completion of an ATF Form 4 (5320.4); </li>
                                        <li>(iv) Completion of all other documents, certificates and forms as SilencerCo and/or its legal counsel and/or other professional services providers may reasonably request relating to the SPEQ Sales or SPEQ Program and any other matters (legal or other) relating to Dealer, all in form and substance reasonably satisfactory to SilencerCo and its counsel; and</li>
                                        <li>(v) Maintenance and retention of records relating to the SPEQ Sales as may be required by SilencerCo or any Governmental Authority. </li>
                                    </ul>
                                </li>
                            </ol>
                        </li>
                        <li>
                            <b><i>Representations and Warranties of Dealer.</i></b> Dealer, as of the Effective Date, represents and warrants to SilencerCo as follows:
                            <ol class="custom-bullets">
                                <li>Authority. Dealer is formed, validly existing, and in good standing under the laws of the jurisdiction of its formation, and has all requisite company power and authority to accept, acknowledge and agree to these Terms and to perform Dealer’s obligations hereunder. </li>
                                <li>Authorization; Enforceability. The acceptance, acknowledgement and agreement of Dealer of these Terms and any other related documents and the consummation by Dealer of the transactions contemplated hereby and thereby have been duly authorized by all necessary company action on the part of Dealer. These Terms have been duly accepted, acknowledged and agreed to by Dealer and constitute a legal, valid, and binding obligation of Dealer, enforceable against Dealer in accordance with the terms herein, except as may be limited by bankruptcy, insolvency, reorganization, moratorium, and other similar laws of general applicability relating to or affecting creditors’ rights or general equity principles (regardless of whether considered at law or in equity). </li>
                                <li>No Conflicts; Consents. The acceptance, acknowledgment and agreement by Dealer of these Terms and any other related documents do not, and the consummation by Dealer of the transactions contemplated hereby and thereby will not (with or without the giving of notice, the lapse of time, or both), contravene, conflict with, or result in a breach or violation of, or a default under (i) Dealer’s articles of incorporation, articles of organization or other constitutive documents; (ii) any judgment, order, decree, statute, law, ordinance, rule, or regulation applicable to Dealer; or (iii) any material contract, agreement, or instrument to which Dealer is a party or otherwise bound. No consent, approval, waiver, or authorization is required to be obtained by Dealer from any Person in connection with the acceptance, acknowledgement, agreement, and performance by Dealer of these Terms and the consummation of the transactions contemplated hereby. </li>
                                <li>FFL; SOT. Dealer maintains a valid FFL or in operation pursuant to a LOA and is a SOT in compliance with all obligations related thereto with the applicable Governmental Authorities. </li>
                            </ol>
                        </li>
                        <li>
                            <b><i>Covenants of Dealer.</i></b>
                            <ol class="custom-bullets">
                                <li>General Compliance with Laws.  Dealer shall at all times comply with all Laws applicable to these Terms, Dealer’s business and performance of its obligations hereunder. Without limiting the generality of the foregoing, Dealer shall (i) at its own expense, maintain all certifications, credentials, licenses, permits, approvals and authorizations necessary to conduct its business relating to the SPEQ Sales, (ii) remain in good standing with the ATF, and (iii) not engage in any activity or transaction involving SilencerCo Products, by way of use, operation or otherwise, that violates any Law.</li>
                                <li>Site Preparation. Dealer, at its sole cost and expense, shall make all site preparations necessary for the provision of the SPEQ Sales at the Dealer Locations as determined by SilencerCo in its sole discretion, including the ability to process photographs and fingerprints, whether in-house or through a dedicated contracted third-party service provider.</li>
                                <li>SilencerCo Product Location. Dealer may not move any SilencerCo Products from the applicable Dealer Locations without SilencerCo’s prior written consent. </li>
                                <li>Inspection and Audit. Dealer shall grant SilencerCo access to the applicable Dealer Locations to inspect the premises for suitability to provide the SPEQ Sales on reasonable prior notice and during regular business hours. In addition, Upon reasonable prior notice, Dealer shall grant SilencerCo access to all of its books and records for the sole purpose of SilencerCo auditing Dealer’s compliance with the terms and conditions of these Terms. </li>
                                <li>No Reverse Engineering. Dealer agrees that it shall not copy, modify, reverse engineer, decompile, translate or disassemble, make any attempt to discover underlying ideas or algorithms, or create derivative works of any of the SilencerCo Products (including the SilencerCo IP Rights therein).</li>
                                <li>Required Notices. Dealer agrees to provide written notice to SilencerCo with regards to any communications, developments or interactions with the ATF or any other Governmental Authority related to Dealer’s FFL, SOT, or any other required licensure, including any inspections, audits, warning letters or revocation notices within seven business days of Dealer’s receipt of any such communications. </li>
                                <li>FFL; SOT. Dealer shall at all times during the Term hereof and for any required period of time in accordance with applicable law following termination of this Agreement maintain a valid FFL or in operation pursuant to a LOA and maintain registration as a SOT in compliance with all obligations related thereto with the applicable Governmental Authorities. Dealer shall upload annually to the Dealer Portal its updated FFL and SOT registration renewals and all information related thereto immediately upon receipt thereof from the ATF. </li>
                            </ol>
                        </li>
                        <li>
                            <b><i>Intellectual Property.</i></b>
                            <ol class="custom-bullets">
                                <li>SilencerCo Intellectual Property. SilencerCo is the sole and exclusive owner of the SilencerCo IP Rights. Dealer shall not in any manner contest the validity of SilencerCo’s exclusive ownership in the SilencerCo IP Rights nor attempt to adopt, use or register any of SilencerCo’s IP Rights other than as expressly permitted pursuant to these Terms. </li>
                                <li>Limited License. SilencerCo hereby grants to Dealer a limited, non-exclusive, non-transferable, non-sublicensable and revocable license for the sole purpose of displaying SilencerCo’s name, logo, trademarks, service marks, or other indicia of source, affiliation or sponsorship (“SilencerCo Marks”) in connection with the performance of Dealer’s obligations hereunder and the facilitation of SPEQ Sales. The foregoing license shall automatically terminate upon the termination or expiration of these Terms or the termination of Dealer’s participation in the SPEQ Program, at which time Dealer will immediately cease and desist use of all SilencerCo Marks. </li>
                                <li>Reservation of Rights. Each Party reserves all rights not expressly granted herein.  </li>
                            </ol>
                        </li>
                        <li>
                            <b><i>Insurance.</i></b>
                            <ol class="custom-bullets">
                                <li>Required Coverages. Dealer shall provide and maintain insurance underwritten by carriers acceptable to SilencerCo and authorized to provide the Required Insurance.  Dealer shall maintain the Required Insurance at its sole expense at all times during the Term.</li>
                                <li>Certificate of Insurance. During the Term, but not more than once annually and upon the request of SilencerCo, Dealer shall provide to SilencerCo certificates of insurance conforming to the requirements of the Required Insurance and certifying that the Required Insurance is in full force and effect.</li>
                            </ol>
                        </li>
                        <li>
                            <b><i>Confidentiality.</i></b> The Parties are party to that certain Non-Disclosure and Confidentiality Agreement, dated around the date hereof (the <b>“Confidentiality Agreement”</b>), and the Parties shall be bound by the confidentiality obligations thereunder and such obligations shall survive the termination or expiration of these Terms pursuant to the terms therein.
                        </li>
                        <li>
                            <b><i>Term and Termination.</i></b>
                            <ol class="custom-bullets">
                                <li>Term. These Terms shall commence on the Effective Date and shall continue until the next upcoming June 30th in any such calendar year (the <b>“Initial Term”</b>).  Upon the expiration of the Initial Term, these Terms shall automatically renew for successive one-year terms (each, a <b>“Renewal Term,”</b> and, together with the Initial Term, the <b>“Term”</b>), unless either Party notifies the other Party in writing that it elects not to renew these Terms and discontinue the business relationship under these Terms at least 30 days prior to the end of the Initial Term or the then-current Renewal Term, as applicable. </li>
                                <li>Termination. </li>
                                    <ul class="no-bullets">
                                        <li>(i) SilencerCo may terminate these Terms, Dealer’s access to the Dealer Portal and participation in in the SPEQ Program, without cause, immediately upon providing written notice to Dealer.</li>
                                        <li>(ii) Dealer may terminate these Terms and discontinue participation in the SPEQ Program at any time, without cause, by providing at least 30 days’ prior written notice to SilencerCo.</li>
                                    </ul>
                                <li>Effect of Termination. Upon any termination or expiration of these Terms or Dealer’s participation in the SPEQ Program, neither Party shall have any further obligations hereunder, except those terms which expressly survive the termination or expiration of these Terms.</li>
                            </ol>
                        </li>
                        <li>
                            <b><i>Indemnification.</i></b>
                            <ol class="custom-bullets">
                                <li>Dealer Indemnity. Dealer shall release, protect, indemnify, and hold harmless SilencerCo and its representatives and Affiliates from and against all Losses sustained or incurred by such parties, including in connection with any third party claims against SilencerCo and its directors, managers, officers, equity holders, employees, agents, representatives, permitted successors and assigns and Affiliates, to the extent such Losses arise out of: (i) bodily injury or property damages directly or indirectly caused by Dealer, its representatives, employees, contractors, agents and Affiliates, (ii) a negligent or wrongful act or omission of Dealer, its representatives, employees, agents, Affiliates and contractors, (iii) a breach by Dealer of any representation, warranty, covenant, term, condition, or other obligation under these Terms, (iv) the performance by Dealer of any of its obligations under these Terms, and (v) a material violation of applicable Laws by Dealer, its representatives, employees, Affiliates and contractors, except in each case, to the extent such liabilities are caused by the gross negligence, willful misconduct, or material breach of these Terms of or by SilencerCo.</li>
                                <li>Effect of Insurance. The obligations of this Section 15 shall apply regardless of the amount of insurance coverage held by Dealer, including any such coverage under any workers’ compensation act, disability act, or other employee benefit act, or any other applicable Law that would limit the amount or type of damages, compensation, or benefits payable by or for Dealer, and shall be both independent of and not limited by or to any Required Insurance carried or provided by Dealer pursuant to these Terms or otherwise.</li>
                            </ol>
                        </li>
                        <li>
                            <b><i>Limitation of Liability.</i></b>
                            <ol class="custom-bullets">
                                <li>No Liability for Consequential, Punitive or Indirect Damages.  SilencerCo nor its representatives, officers, directors, managers, employees, equity holders, agents, Affiliates, successors and permitted assigns is liable for consequential, indirect, incidental, special, exemplary, punitive or enhanced damages, lost profits or revenues or diminution in value, arising out of or relating to any breach of these Terms, regardless of (i) whether such damages were foreseeable, (ii) whether or not it was advised of the possibility of such damages, and (iii) the legal or equitable theory (contract, tort, or otherwise) upon which the claim is based, and notwithstanding the failure of any agreed or other remedy of its essential purpose.</li>
                                <li>Maximum Liability. Except for instances of Fraud, gross negligence and willful misconduct, SilencerCo’s aggregate liability arising out of or related to this Agreement, whether arising out of or related to breach of contract, tort (including negligence) or otherwise, shall not exceed the total of the amounts paid to SilencerCo by Dealer pursuant to these Terms in the 12-month period preceding the event giving rise to the claim.</li>
                            </ol>
                        </li>
                        <li>
                            <b><i>Independent Contractor Relationship.</i></b> In the performance of the obligations hereunder, both Parties are acting as independent contractors and neither Party undertakes to perform any obligation of the other, whether regulatory or contractual, or to assume any responsibility for the other’s business or operations.  Nothing in these Terms shall be deemed to constitute a partnership or joint venture between SilencerCo and Dealer.  Neither Party shall hold itself out as having any authority to enter into any contract or create any obligation or liability on behalf of or binding upon the other Party.  Each of SilencerCo and Dealer shall separately assume complete responsibility for obligations under any applicable employers’ liability, workmen’s compensation, social security, unemployment insurance, occupational safety and health administration laws and other applicable laws with respect to its own hired or leased employees or contractors.  
                        </li>
                        <li>
                            <b><i>Miscellaneous.</i></b>
                            <ol class="custom-bullets">
                                <li>Expenses. All costs and expenses (including all legal fees) incurred in connection with these Terms are to be paid by the Party incurring such expenses. Each Party shall be responsible for all costs and expenses incurred in the performance of its obligations hereunder.</li>
                                <li>Waivers and Amendments. Any provision of these Terms may be amended, waived or modified at any time by written notice from SilencerCo to Dealer and shall be effective when posted within the Dealer Portal.</li>
                                <li>Governing Law. These Terms and all actions arising out of or in connection with these Terms shall be governed by and construed in accordance with the laws of the State of Utah, without regard to the conflicts of law provisions of the State of Utah or of any other state.</li>
                                <li>Jurisdiction and Venue. Each of the Parties irrevocably consents to the exclusive jurisdiction of, and venue in, the state courts located in Salt Lake City, Utah (or in the event of exclusive federal jurisdiction, the federal courts located in Salt Lake City, Utah), in connection with any matter based upon or arising out of these Terms or the matters contemplated herein, and agrees that process may be served upon them in any manner authorized by the laws of the State of Utah for such Persons.</li>
                                <li>WAIVER OF JURY TRIAL. EACH PARTY HEREBY WAIVES ITS RIGHTS TO A JURY TRIAL OF ANY CLAIM OR CAUSE OF ACTION BASED UPON OR ARISING OUT OF THESE TERMS, OR THE SUBJECT MATTER HEREOF. THE SCOPE OF THIS WAIVER IS INTENDED TO BE ALL-ENCOMPASSING OF ANY AND ALL DISPUTES THAT MAY BE FILED IN ANY COURT AND THAT RELATE TO THE SUBJECT MATTER OF THIS TRANSACTION, INCLUDING, WITHOUT LIMITATION, CONTRACT CLAIMS, TORT CLAIMS (INCLUDING NEGLIGENCE), BREACH OF DUTY CLAIMS, AND ALL OTHER COMMON LAW AND STATUTORY CLAIMS. THIS SECTION HAS BEEN FULLY DISCUSSED BY EACH OF THE PARTIES HERETO AND THESE PROVISIONS WILL NOT BE SUBJECT TO ANY EXCEPTIONS. EACH PARTY HERETO HEREBY FURTHER WARRANTS AND REPRESENTS THAT SUCH PARTY HAS REVIEWED THIS WAIVER WITH ITS LEGAL COUNSEL, AND THAT SUCH PARTY KNOWINGLY AND VOLUNTARILY WAIVES ITS JURY TRIAL RIGHTS FOLLOWING CONSULTATION WITH LEGAL COUNSEL.</li>
                                <li>Binding Effect and Assignment. These Terms and all of the provisions hereof shall be binding upon and shall inure to the benefit of the Parties and their respective successors and permitted assigns.  Neither these Terms nor any of the rights, interests or obligations hereunder shall be assigned, directly or indirectly, including by operation of law, by any Party without the prior written consent of the other Party; provided, however, that SilencerCo shall be permitted, without the consent of Dealer, to (i) assign any or all of its rights hereunder to one or more of its Affiliates, and (ii) assign these Terms to a subsequent purchaser of all or a substantial portion of the equity or assets of SilencerCo or other successor entity in the event of SilencerCo’s merger, spin-ff, consolidation or other reorganization. </li>
                                <li>Interpretation. In these Terms: (i) the singular includes the plural and vice versa; (ii) reference to any document, Law, or standard means such document, Law, or standard as amended from time to time; (iii) “include” or “including” means including without limiting the generality of any description preceding such term; (iv) the term “or” is not exclusive and shall have the meaning commonly ascribed to the term “and/or”; (v) the phrase “these Terms” and the terms “hereof,” “herein,” “hereby,” “hereunder” and derivatives or similar words refer to these entire Terms; and (vi) headings are for convenience only and do not constitute a part of these Terms.</li>
                                <li>Entire Agreement. These Terms constitute and contain the entire agreement between the Parties and supersede any and all prior agreements, negotiations, correspondence, understandings and communications among the Parties, whether written or oral, respecting the subject matter hereof.</li>
                                <li>Notices. All notices, demands and other communications to be given or delivered to any Party under or by reason of the provisions of these Terms will be in writing.</li>
                                <li>Severability.  If any provision of these Terms are deemed or held to be illegal, invalid or unenforceable, these Terms shall be considered divisible and inoperative as to such provision to the extent it is deemed to be illegal, invalid or unenforceable, and in all other respects these Terms shall remain in full force and effect; provided, however, that if any provision of these Terms are deemed or held to be illegal, invalid or unenforceable the Parties agree to replace such illegal, invalid or unenforceable provision with a provision that is legal, valid and enforceable that achieves the original intent of the Parties as closely as possible. Further, should any provision contained in these Terms ever be reformed or rewritten by any governmental authority of competent jurisdiction, such provision as so reformed or rewritten shall be binding upon all Parties.</li>
                            </ol>
                            <br><br>
                            31879303_v3
                        </li>
                    </ol>
                </div>
            </div>
            <div class="col-md-12 py-3 mt-3 mb-2">
                <div class="d2d-btn mx-auto" 
                    v-if="currentLocation.speq_invite_status == 2 || currentLocation.speq_invite_status == 3">
                    ACCEPTED
                </div>
                <template v-else>
                    <button
                        @click="acceptSpeqInvite(3)"
                        class="d2d-btn mr-3"
                    >
                        I AGREE
                    </button>
                    <button
                        @click="acceptSpeqInvite(4)"
                        class="d2d-btn-dont-agree"
                    >
                        I DO NOT AGREE
                    </button>
                </template>
            </div>
        </div>

        
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore, mapGetters } from "vuex";
export default {
    props: [],
    emits: [],
    components: {},
    setup() {
        const store = useStore();
        let currentLocation = computed(function () {
            return store.state.currentLocation;
        });

        let user = computed(function () {
            return store.state.user;
        });
        let locations = computed(function () {
            return store.state.locations;
        });

        function setCurrentLocation(val) {
            store.commit("setCurrentLocation", val);
        }

        return {
            store,
            user,
            locations,
            currentLocation,
            setCurrentLocation
        };
    },
    data() {
        return {
            locationId: "",
            silencers: {
                rifle: {
                    name: "Rifle Silencers",
                    data: [
                        {
                            name: "Scythe-Ti",
                            sku: "SU5328",
                            commission: "200",
                            starred: true,
                            high_earner: false,
                        },
                        {
                            name: "Omega 300 DTM",
                            sku: "SU4735",
                            commission: "200",
                            starred: true,
                            high_earner: true,
                        },
                        {
                            name: "Omega 36M",
                            sku: "SU4735",
                            commission: "200",
                            starred: true,
                            high_earner: true,
                        },
                        {
                            name: "Hybrid 46 DTM",
                            sku: "SU5107",
                            commission: "200",
                            starred: true,
                            high_earner: false,
                        },
                        {
                            name: "Hybrid 46M",
                            sku: "SU5107",
                            commission: "200",
                            starred: true,
                            high_earner: false,
                        },
                        {
                            name: "Chimera 300",
                            sku: "SU2616",
                            commission: "175",
                            starred: false,
                            high_earner: false,
                        },
                        {
                            name: "Saker 556K ASR",
                            sku: "SU2256",
                            commission: "175",
                            starred: false,
                            high_earner: false,
                        },
                        {
                            name: "Velos LBP",
                            sku: "SU5059",
                            commission: "200",
                            starred: true,
                            high_earner: false,
                        },
                    ],
                },
                pistol: {
                    name: "Pistol Silencers",
                    data: [
                        {
                            name: "OSPREY 45 2.0",
                            sku: "SU5185",
                            commission: "150",
                            starred: false,
                            high_earner: false,
                        },
                        {
                            name: "OSPREY 9 2.0",
                            sku: "SU5184",
                            commission: "150",
                            starred: false,
                            high_earner: false,
                        },
                        {
                            name: "OMEGA 45K",
                            sku: "SU2254",
                            commission: "130",
                            starred: false,
                            high_earner: false,
                        },
                        {
                            name: "OMEGA 9K",
                            sku: "SU1544",
                            commission: "130",
                            starred: false,
                            high_earner: false,
                        },
                    ],
                },
                rimfire: {
                    name: "Rimfire Silencers",
                    data: [
                        {
                            name: "SPARROW 22",
                            sku: "SU75",
                            commission: "60",
                            starred: false,
                            high_earner: false,
                        },
                        {
                            name: "SWITCHBACK",
                            sku: "SU5085",
                            commission: "100",
                            starred: false,
                            high_earner: false,
                        },
                    ],
                },
                shotgun: {
                    name: "Shotgun Silencers",
                    data: [
                        {
                            name: "SALVO 12",
                            sku: "SU823",
                            commission: "200",
                            starred: false,
                            high_earner: false,
                        },
                    ],
                },
            },
            locations: [],
        };
    },
    computed: {
        
        
    },
    mounted() {
        this.getLocations();
    },
    methods: {
        getLocations() {
            axios
                .post("/api/get-locations", { user_id: this.user.id })
                .then((data) => {
                    this.locations = data.data.result;
                    if (data.data.result.length == 1) {
                        this.locationId = data.data.result[0].id;
                    }
                });
        },
        goToOnboarding(id) {
            this.$router.push({
                name: "directToDealerOnboarding",
                params: { id: id },
            });
        },
        acceptSpeqInvite(status) {
            // status = 3 - accept ; status = 4 - do not accept
            // this.currentLocation.speq_invite_status = 3; //ACCEPTED
            this.currentLocation.speq_invite_status = status;
            this.store.dispatch("acceptSpeqInvite", {id: this.currentLocation.id, speq_status: status})
                .then(res => {
                    if (status == 3) {
                        this.store.dispatch("getLocations", this.user.id).then((resp) => {
                            let selectedLocation = this.locations.filter(
                                (x) => x.id == this.currentLocation.id
                            );

                            this.setCurrentLocation(selectedLocation[0]);
                            // this.updateRecords(selectedLocation[0], this.user);
                        });
                    } else {
                        this.$router.push({ name: "dashboard" });
                    }
                });
        },
    },
    
};
</script>
<style scoped lang="scss">
.btn-join-d2d {
    font-size: 12px;
    word-wrap: break-word;
    white-space: break-spaces;
}
.btn-join-d2d:hover,
.btn-join-d2d.active {
    color: white !important;
}

.d2d-header {
    text-align: center;
    background: #ededed;
    padding: 20px;
    border-radius: 30px;
    h1 {
        font-size: 2rem;
        color: #000000;
    }
    .d2d-h-subtitle {
        font-size: 1.6rem;
        font-weight: 600;
        color: #000000;
        span {
            font-weight: 800;
            font-family: "TT-Norms-ExtraBold";
        }
    }
}

.d2d-onboarding {
    @media (max-width: 600px) {
        width: 100%;
        padding: 1rem !important;
    }
    width: 80%;
    margin: auto;
    h2 {
        font-size: 2rem;
        color: #000000;
    }

    .step-container {
        display: flex;
        gap: 20px;
        margin-top: 10px;
        margin-bottom: 20px;
        .step-sub-container {
            @media (max-width: 600px) {
                width: 100%;
                padding: 1rem !important;
            }
            flex: 1;
            padding: 25px;
            background: #2d2b29;
            display: flex;
            color: white;
            gap: 20px;
            border-radius: 12px;
            width: 49%;
            .step-holder {
                .step-text {
                    font-size: 28px;
                    font-family: "TT-Norms-ExtraBold";
                }
                .step-number {
                    font-size: 50px;
                    color: #ff7f00;
                    font-family: "TT-Norms-ExtraBold";
                    margin-top: -25px;
                }
            }
            .step-info {
                width: 80%;
                margin: auto;
                font-size: 22px;
                span {
                    color: #ff7f00;
                }
            }
        }
    }

    .d2d-btn {
        width: 225px;
        height: 45px;
        border-radius: 10px;
        background: #ff7f00;
        color: white;
        border-color: #ff7f00;
        font-weight: 500;
        border: 1px solid #ff7f00;
        padding: 10px 30px;
        &:hover {
            color: #ff7f00;
            background-color: transparent;
        }
        font-family: "TT-Norms-ExtraBold";
    }

    .d2d-btn-dont-agree {
        width: 225px;
        height: 45px;
        border-radius: 10px;
        background: #e7262b;
        color: white;
        border-color: #e7262b;
        font-weight: 500;
        border: 1px solid #e7262b;
        padding: 10px 30px;
        &:hover {
            color: #e7262b;
            background-color: transparent;
        }
        font-family: "TT-Norms-ExtraBold";
    }

    a {
        color: #ff7f00;
        text-decoration: none;
    }

    ol {
        padding: 0;
        font-size: 18px;
        line-height: 2rem;
        color: black;
        padding-left: 5px;
    }
    p {
        color: black;
    }
    h2 {
        span {
            color: #ff7f00;
        }
    }
    .accordion-button {
        font-size: 25px;
    }

    .accordion {
        max-width: 550px;
        margin-left: 45px;
        margin-top: 10px;
        @media (max-width: 600px) {
            margin-left: 0px;
        }
    }

    .accordion-button:not(.collapsed) {
        background: none;
        color: #ff7f00;
    }
    .accordion-button.collapsed::after {
        content: "";
        display: block;
        box-sizing: border-box;
        position: absolute;
        width: 15px;
        height: 15px;
        border-bottom: 3px solid;
        border-right: 3px solid;
        transform: rotate(45deg);
        left: 4px;
        top: 30%;
        background-image: unset;
        right: 25px;
        color: #ff7f00;
    }

    .accordion-button:not(.collapsed)::after {
        content: "";
        display: block;
        box-sizing: border-box;
        position: absolute;
        width: 15px;
        height: 15px;
        border-bottom: 3px solid;
        border-right: 3px solid;
        transform: rotate(225deg);
        left: 4px;
        top: 40%;
        background-image: unset;
        right: 25px;
        color: #ff7f00;
    }
    .accordion-item {
        border: unset;
        border-top: 2px solid #efefefef;
    }
    .theader {
        font-size: 18px;
        color: #bcbcbc;
        margin-bottom: 5px;
    }
    .tbody {
        font-size: 18px;
        color: #000000;
    }
    .starred {
        vertical-align: baseline;
        margin-left: 5px;
        margin-right: 5px;
        width: 12px;
    }
    .high-earner {
        font-size: 12px;
        color: #ff7f00;
        font-style: italic;
    }
    .accordion-body {
        .trow {
            border-top: 1px solid #fefe;
            padding-top: 5px;
            padding-bottom: 5px;
        }
    }
}
.location-name {
    color: #000000 !important;
    text-transform: uppercase;
    font-weight: 800;
    font-family: "TT-Norms-ExtraBold";
}

.bold {
    font-family: "TT-Norms-ExtraBold";
    color: #000000 !important;
}

.sign-up-badge {
    background-color: #ff7f00 !important;
    font-family: "TT-Norms-ExtraBold";
    padding: 5px 20px 5px 20px !important;
    font-size: 12px;
}

.sign-up-badge:hover {
    cursor: pointer;
}
@counter-style customlist {
    system: fixed;
    symbols: '(a)' '(b)' '(c)' '(d)' '(e)' '(f)' '(g)' '(h)' '(i)' '(j)';
    suffix: " ";
}
.custom-bullets > li {
    list-style: customlist;
}
</style>
